import keyMirror from 'keymirror';

export const EngineeringBallastMapsActionsConstants = keyMirror({
  BALLAST_GENERATING_START: undefined,
  BALLAST_GENERATING_SUCCESS: undefined,
  BALLAST_GENERATING_FAILED: undefined,
  BALLAST_GENERATING_RESET: undefined,
});
